/**
 * Baacal — color sibling prefetch (draft).
 * Siblings are separate products (custom.alternate_colors), so full page nav is correct.
 * Prefetch on hover/focus cuts perceived wait without AJAX soft-nav.
 */
(function () {
  var ATTR = 'data-baacal-sibling-prefetch';
  var DONE = 'data-baacal-prefetched';

  function prefetch(url) {
    if (!url || typeof url !== 'string') return;
    try {
      var abs = new URL(url, location.origin);
      if (abs.origin !== location.origin) return;
      if (abs.pathname === location.pathname) return;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'document';
      link.href = abs.pathname + abs.search;
      document.head.appendChild(link);
    } catch (e) {
      /* ignore */
    }
  }

  function onIntent(event) {
    var a = event.target && event.target.closest ? event.target.closest('a[' + ATTR + ']') : null;
    if (!a || a.getAttribute(DONE) === '1') return;
    a.setAttribute(DONE, '1');
    prefetch(a.getAttribute('href'));
  }

  document.addEventListener('pointerenter', onIntent, true);
  document.addEventListener('focusin', onIntent, true);
})();
